import { render, staticRenderFns } from "./ReportOnline.vue?vue&type=template&id=284e3a96"
import script from "./ReportOnline.vue?vue&type=script&lang=ts"
export * from "./ReportOnline.vue?vue&type=script&lang=ts"
import style0 from "./ReportOnline.vue?vue&type=style&index=0&id=284e3a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports